import { RpcSuccess } from '@dealroadshow/json-rpc-dispatcher';
import { type IDispatcher } from '@creditflowresearch/json-rpc-dispatcher/dispatcher-cfr';
import Request from '@framework/api/Rpc/Request';
import isServer from '@framework/router/Next/isServer';

export default class BaseRepository {
  protected constructor(protected rpc: IDispatcher) {
  }

  protected async abortableCall(request: Request, tags: string = '') {
    if (isServer()) {
      const response = await this.rpc.call<RpcSuccess>(request);
      return response.getResult().payload;
    }

    if (tags) {
      tags = request.method.concat(tags);
    } else {
      tags = request.method;
    }
    this.rpc.abort(tags);

    const response = await this.rpc.call<RpcSuccess>(request, { tags });
    return response.getResult().payload;
  }

  /**
   * RPC method tagged with `.rpcMethod`, which useQuery uses as its default cache key.
   * Deliberately not abortable: useQuery discards stale responses itself, and aborting
   * by method would cancel other components' requests for the same method.
   */
  protected createRpcMethod<TResult>(method: string): ((payload: unknown) => Promise<TResult>) & { rpcMethod: string } {
    const fn = async (payload: unknown): Promise<TResult> => {
      const response = await this.rpc.call<RpcSuccess>(new Request(method, payload as object));
      return response.getResult().payload;
    };

    return Object.assign(fn, { rpcMethod: method });
  }
}
